import { useEffect, useMemo, useState } from "react";
import _ from "underscore";

export const useAssetAllocationPDF = ({ editData, assignValues, options }) => {

    const [assetTypeCount, setAssetTypeCount] = useState({ laptop: 0, mouse_keyboard: 0, charger: 0, mobile_device: 0, headset: 0, inverter: 0 });
    const dataContent = {
        table: [
            { nomenclature: "Laptop/Desktop", count: assetTypeCount?.laptop },
            { nomenclature: "Mouse and Keyboard (Only for Desktop)", count: assetTypeCount?.mouse_keyboard },
            { nomenclature: "Adapter Charger", count: assetTypeCount?.charger },
            { nomenclature: "Smart Device (As per Project requirement)", count: assetTypeCount?.mobile_device },
            { nomenclature: "Headset", count: assetTypeCount?.headset },
            { nomenclature: "Inverter & Battery", count: assetTypeCount?.inverter },
        ],
        attributes: [
            { label: "Laptop service Tag", value: editData["Service Tag"] },
            { label: "Charger Sr.No", value: editData?.monitor_charger_sr_no },
            { label: "Inverter & Battery Sr.No", value: editData["invertor"] },
        ]
    }

    useEffect(() => {
        let count = { laptop: 0, mouse_keyboard: 0, charger: 0, mobile_device: 0, headset: 0, inverter: 0 };
        [editData?.asset_id, ...assignValues?.other_assets]?.forEach(id => {
            const asset = _.findWhere(options?.assets_details, { asset_id: id });
            const assetType = _.findWhere(options?.asset_type, { asset_type_id: asset?.asset_type_id });
            if (assetType?.asset_type_key === "laptop" || assetType?.asset_type_key === "desktop") {
                count.laptop++;
            } else if (assetType?.asset_type_key === "mouse" || assetType?.asset_type_key === "key_board") {
                count.mouse_keyboard++;
            } else if (assetType?.asset_type_key === "mobile_device") {
                count.mobile_device++;
            } else if (assetType?.asset_type_key === "inverter") {
                count.inverter++;
            }
        })
        setAssetTypeCount(count);
    }, [assignValues])

    return useMemo(() => ({
        dataContent
    }), [dataContent])
}